<template>
  <div class="nothingBox" :style="{width: width ? width+'px' : '100%'}">
    <img :src="noData" alt="">
    <p>{{ nothing || '暂无数据' }}</p>
    <slot name="nothing" />
    <div class="btnBox mt20">
      <slot name="btn" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    nothing: {
      type: String
    },
    width: {
      type: String
    }
  },
  data() {
    return {
      noData: 'https://oss.zhihanyun.com/1593313965372_no_data.png'
    }
  }
}
</script>
<style lang="scss" scoped type="text/scss">
  .nothingBox{
    text-align: center;
    padding: 100px 0;
    img{
      margin: 50px auto 0 auto;
      width: 240px;
    }
    p{
      text-align: center;
      font-size: 14px;
      color: #999;
      line-height: 30px;
    }
  }
</style>
